import { OverlayProvider } from 'overlay-kit';
import { Outlet } from 'react-router-dom';

export const RootLayout = () => (
  <OverlayProvider>
    <Outlet />
  </OverlayProvider>
);
